import Phase from "@/models/server/Phase";

export default class PhaseRequest{
    phase : Phase | null = null;
}